import { ARBITRUM, AVALANCHE, CANTO } from "config/chains";
import { TOKENS_BY_SYMBOL_MAP } from "./tokens";

const oneInchTokensMap = {
  [ARBITRUM]: {
    BTC: "WBTC",
  },
  [AVALANCHE]: {
    BTC: "BTC.b",
    ETH: "WETH.e",
    WBTC: "WBTC.e",
  },
};

export function get1InchSwapUrl(chainId: number, from?: string, to?: string) {
  if (chainId === CANTO) {
    return "https://app.slingshot.finance/swap/Canto/WCANTO";
  }
  const rootUrl = `https://app.1inch.io/#/${chainId}/simple/swap`;
  const chainTokensMap = TOKENS_BY_SYMBOL_MAP[chainId];
  const isInvalidInput = !from || !to || !chainTokensMap[from] || !chainTokensMap[to];
  if (isInvalidInput) {
    return rootUrl;
  }
  const fromToken = oneInchTokensMap[chainId]?.[from] || from;
  const toToken = oneInchTokensMap[chainId]?.[to] || to;
  return `${rootUrl}/${fromToken}/${toToken}`;
}

export function getLeaderboardLink(chainId) {
  if (chainId === CANTO) {
    return "https://www.cad.house/canto/leaderboard";
  }
  return "https://www.cad.house";
}

export const headerLinks = [
  // {
  //   title: "Dashboard",
  //   ulr: "/dashboard",
  // },
  {
    title: "Earn",
    ulr: "/earn",
  },
  // {
  //   title: "Trade",
  //   ulr: "/trade",
  // },
  // {
  //   title: "Leaderboard",
  //   ulr: "/leaderboard",
  // },
];

export enum OutgoingLinks {
  YIELD_LEARN_MORE = "https://cadenceprotocol.gitbook.io/cadence-protocol/introduction-to-cadence/welcome-to-cadence",
}
